export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-problem-1.9fa85fac.png";